export default "__VITE_ASSET__CM0zpkHN__"